import styled from "styled-components";

const BlogItemStyleWrapper = styled.article`
  color: rgba(255, 255, 255, 0.7);
  font-family: "Poppins";
  a,
  p,
  span {
    color: inherit;
    display: block;
  }
  a,
  span {
    font-family: "Poppins";
  }

  .blog_thumb {
    overflow: hidden;
    p{
      margin-bottom: 0;
    }
    img {
      transition: all 0.4s;
      height: 307px;
      width: 100%;
      object-fit: cover;
    }
    &:hover {
      img {
        transform: scale(106%);
      }
    }
  }
  .blog_content {
    padding: 32px 30px;
    background: #131740;
    .blog_meta {
      display: flex;
      align-items: center;
      column-gap: 6px;
      text-transform: uppercase;
      margin-bottom: 10px;
      .author{
        font-size: 14px;
        display: flex;
        align-items: center;
        column-gap: 5px;
        svg {
          font-size: 16px;
          color: #FFF;
        }
      }

      .time_stamp {
        font-size: 14px;
        margin-left: auto;
        display: flex;
        align-items: center;
        column-gap: 5px;
        svg {
          font-size: 16px;
          color: #FFF;
        }
      }
    }

    .blog_title {
      font-size: 22px;
      line-height: 33px;
      color: #ffffff;
      margin-bottom: 15px;
      margin-top: 15px;

      &:hover {
        color: rgba(255, 255, 255, 0.7);
      }
    }
    p {
      font-weight: 500;
    }

    .blog_description{
      font-size: 14px;
      color: #ffffff;
    }

    .blog_footer {
      color: #ffffff;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      a,p {
        text-transform: capitalize;
        transition: all 0.4s;
        color : #FF06B7;
        font-family: "Poppins";
        cursor: pointer;
        font-size: 14px;
        border-bottom: 1px solid #FF06B7;

        &:hover {
          color: #FFF;
          border-color: #FFF;
        }
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .blog_content {
      .blog_title {
        font-size: 20px;
      }
    }

    .blog_thumb {
      img {
        height: 250px;
      }
    }

    .blog_content {
      padding: 25px 20px;
    }

    .blog_meta {
      margin-bottom: 10px;
      .author{
        font-size: 14px;
      }

      .time_stamp {
        font-size: 14px;
      }
    }

    .blog_footer {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 350px) {
  .blog_content {
    .blog_meta {
      .author{
        font-size: 12px;
      }
      .time_stamp {
        font-size: 12px;
      }
    }
   }
  }
`;



export default BlogItemStyleWrapper;
